/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { useAppContext } from "../libs/contextLib";
import { httpClient } from "../request";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { statusToIcon } from "../status";

export default function Login(properties) {
  const { userHasAuthenticated } = useAppContext();
  const [validated, setValidated] = useState(false);

  const history = useHistory();

  const [state, setState] = useState({
    app: "",
    username: "",
    key: "",
    password: "",
    accountType: "",
    result: false,
  });

  const handleChange = (e) => {
    const { id, value } = e.target;

    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleLogin = (e) => {
    const form = e.currentTarget;

    const isValid = form.checkValidity();

    e.preventDefault();
    e.stopPropagation();

    setValidated(true);

    if (!isValid) return;

    const loginData = {
      username: state.username,
      password: state.password,
      app: state.app,
      key: state.key
    }

    httpClient
      .post("/private/authenticate", null, {
          headers: { "User-Agent": "LeetAuth" },
          params: loginData,
        }
      )
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          const token = responseData;

          // localStorage only supports strings
          localStorage.setItem("token", JSON.stringify(token));

          userHasAuthenticated(true);

          history.push("/");
        } else {
          setState({
            identifier: "",
            password: "",
            result: {
              status: "danger",
              message: "An unknown error has occurred",
            },
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setState({
              identifier: "",
              password: "",
              result: {
                status: "danger",
                message: responseData.error,
              },
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setState({
            identifier: "",
            password: "",
            result: {
              status: "danger",
              message: error.message,
            },
          });
        }
      });
  };

  return (
    <div className="Login">
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-4 mx-auto">
            {state.result && (
              <Alert variant={state.result.status}>
                <span className="mr-1">
                  <FontAwesomeIcon icon={statusToIcon[state.result.status]} />
                </span>
                <span>{state.result.message}</span>
              </Alert>
            )}

            <Form noValidate validated={validated} onSubmit={handleLogin}>
              <Form.Group controlId="accountType">
                <Form.Control
                  as="select"
                  onChange={handleChange}
                  defaultValue={`DEFAULT`}
                >
                  <option value="DEFAULT" disabled>
                    Select a login method...
                  </option>
                  <option value="developer">Developer</option>
                  <option value="apiKey">API Key</option>
                  <option value="modAdmin">Mod/admin</option>
                </Form.Control>
              </Form.Group>

              {(state.accountType === "developer" ||
                state.accountType === "modAdmin") && (
                <div>
                  <Form.Group controlId="username">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter username"
                      value={state.username}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a username
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={state.password}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a password
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              )}

              {(state.accountType === "apiKey" ||
                state.accountType === "modAdmin") && (
                <Form.Group controlId="app">
                  <Form.Label>App ID</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter app ID"
                    value={state.app}
                    onChange={handleChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter an app ID
                  </Form.Control.Feedback>
                </Form.Group>
              )}

              {state.accountType === "apiKey" && (
                <Form.Group controlId="key">
                  <Form.Label>API key</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter API key"
                    value={state.key}
                    onChange={handleChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter an API key
                  </Form.Control.Feedback>
                </Form.Group>
              )}

              <Form.Group controlId="formBasicCheckbox">
                <Form.Check type="checkbox" label="Remember me" />
              </Form.Group>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Login.js